import styled from 'styled-components';

export const HeadingView = styled.section` 
    width: 100%;
    background: #F1FEFF;
    padding-top: 60px;
    color: #000000;
    font-size: 18px;
    font-weight: 500;
    font-family: 'Jost', sans-serif;
    line-height: 26px;
    @media screen and (max-width: 1024px) {
         padding-top: 170px;
   }   
   @media screen and (max-width: 991px) {
         padding-top: 150px;
   } 
`;

export const HeadingTitle = styled.h2`
    color: #01606F; 
    font-size: 40px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 60px;
   @media screen and (max-width:1199px) {
           font-size: 38px;
           line-height: 50px;
   }

   @media screen and (max-width: 991px) {
           font-size: 35px;
        line-height: 45px;
       margin-top: 30px;
   }

     @media screen and (max-width: 767px) {
       font-size: 30px;
        line-height: 38px;
     }
`;

export const HeadingText = styled.p`
    margin: 0;    
`;

export const KidsFoundationForm = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding: 30px 0px 50px;
`;

export const KidsFoundationFormWrap = styled.div`
    width: 100%;
    background: #fff;
    padding: 20px 20px 30px 20px;
    border-radius: 15px;
    box-shadow: 0px 10px 10px #0000000D;

    .dropdown-toggle{
        min-width: 568px;
        width: 100%;
        background: #F3F3F3;
        text-align: left;
        padding: 15px 72px 14px 24px;
        &::after{
            top: 16px;
        }
    @media screen and (max-width:991px){
              min-width: inherit;   
              white-space: normal;
      }     
}

    .dropdown-menu.show{
        0px 0px auto auto !important;
    }

    &:focus-visible{
        box-shadow: none;
    }
`;

export const SubmitForm = styled.form`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 24px;
    &.submit-rating-form{
          .image-close-btn {
            background: #01606F;
            margin-left: -28px;
            border: none;
            margin-top: 1px;
           @media screen and (max-width:767px){
              margin-right: 12px;
             padding: 6px 9px;
          }
         @media screen and (max-width:360px){
             padding: 6px 10px;
             margin-right: 0px;
          }
}
    }
    .form-rating-textarea{
        width: 100%;
    }
`;

export const FormBox = styled.div`
    width: 100%;
    max-width: calc(50% - 12px);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
     @media screen and (max-width:991px){
       max-width:100%;
       padding:0px;
     }
    p{
        margin-bottom: 0px;
        margin-left: 10px;

    }
        .rating-review-error {
            display: flex;
            width: 100%;
}
`;

export const FormBoxTitle = styled.label`
    width: 100%;
    color: #333333;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 10px;
`;

export const FormRatingGroup = styled.div`
    max-width: 273px;    
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 10px;
    background: #F3F3F3;
    padding: 10px;
    border-radius: 10px;

    p{
        margin-bottom: 0px;
    }
`;

export const FormRatingStar = styled.div`
    max-width: 37px;
    width: 100%;
    height: 36px;
    overflow: hidden;
    cursor: pointer;

    img{
        width: 100%;
        height: 100%;
        display: block;
    }
`;

export const FormRatingButton = styled.button`
    border: none;
    background: transparent;
    color:#333333;
    font-size: 14px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 20px;
    transition: 0.2s all ease-in-out;

    &:hover{
        color: #F9DC70;
    }
`;

export const FormBottomGroup = styled.div`
    width: 100%;
`;

export const FormBottomGroupWrap = styled.div`
    width: 100%;
    background: #F3F3F3;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 30px;

    textarea.form-control {
        background: #f3f3f3;
        padding: 0px;
        border: none;
        min-height: 300px;
    }
`;

export const FormButtonGroup = styled.div`
    width: 100%;
    margin-top: 10px;
    padding: 20px 0px 0px;
    border-top: 1px solid #fff;
    @media screen and (max-width:767px){
     padding: 0px;
    }
`;

export const FormButtonGroupImageWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    row-gap: 26px;
`;

export const UploadImageWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 26px;
`;

export const FormButtonGroupImage = styled.div`
    border-radius: 10px;
    position: relative;
    z-index: 3;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 15px;
    flex-wrap: wrap;

    img{
        width: 100%;
        height: 100%;
        max-width: 120px;
        max-height: 120px;
        display: block;
        border-radius: 10px;
    }
`;

export const CloseButtonIcon = styled.button`
    width: 36px;
    height: 36px;
    border: none;
    position: absolute;
    top: -12px;
    right: -10px;
    background: transparent;
    max-width: 36px;
    max-height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    z-index: 4;

    img{
        width: 100px;
        height: 100%;
        display: block;
    }
`;


export const FileUploadButtonGroup = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 15px;
    cursor: pointer;    
    @media screen and (max-width:767px){
       flex-wrap: wrap;
       row-gap:15px;
    }
    .form-control[type=file] {
        background: transparent;
        opacity: 0;
        top: 0;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .add-image-button{
        max-width: 141px;
        background: #01606F;
        max-height: 48px;
        box-shadow: 3px 5px 20px #00000033;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
     white-space: nowrap;
        color: #fff;
        position: relative;
        transition: all 0.5s ease-in-out;
        width:100%;
        @media screen and (max-width:767px){
           max-width: inherit;
        }
        &:hover{
            background: #FFD495;
            color: #333;
        }

        svg{
            fill: #fff;
            transition: all 0.5s ease-in-out;
        }

        &:hover svg{
            fill: #333;
        }
    }

    .add-video-button{
        background: #F9DC70;
        color: #333333;
    }

    .form-label{
        margin: 0;
        margin-top: 0;
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        font-family: 'Jost', sans-serif;
        padding: 15px 21px;
    }

 

`;

export const FileUploadText = styled.label`
    color: #333333;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 22px;
    margin-left: 5px;
`;

export const FileUploadTextSpan = styled.span`
    color: #333333;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 22px;
`;

export const KidsFoundationFormButton = styled.div`
    
    .btn-outline-success-blue{
        padding: 12px 40px;
    }
`;  

export const FormTextIcon = styled.span`
    margin-right: 5px;
    width: 16px;
    height: 16px;
      display: inline-flex;

`;

export const FormTextIconTwo = styled.span`
    margin-right: 5px;
    width: 16px;
    height: 16px;
    display: inline-flex;

`;